import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take, takeWhile } from 'rxjs/operators';
import { FeldBeschreibung } from '../../domain/model/feldbeschreibung.model';
import {
    SettingsFeldBeschreibungDetailComponent,
} from '../settings-feldbeschreibung-detail/settings-feldbeschreibung-detail.component';
import { FeldBeschreibungService } from '../../service/feldbeschreibung/feldbeschreibung.service';
import { ObjectPathService } from '../../service/common/deep-path/deep-path.service';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'redispatch-settings-feldbeschreibung',
    templateUrl: './settings-feldbeschreibung-page.component.html',
    styleUrls: [
        './settings-feldbeschreibung-page.component.scss',
    ],
    standalone: false,
})
export class SettingsFeldBeschreibungPageComponent implements OnInit, OnDestroy {

    public feldBeschreibungList = new MatTableDataSource<FeldBeschreibung>();
    public componentDestroyed = false;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    private datasourceFilter = ((data: FeldBeschreibung, filter: string) => {
        if (!filter) {
            return true;
        }
        filter = filter.toLowerCase();
        return (
            data.title.toLowerCase().indexOf(filter) !== -1 ||
            (data.hilfetext !== null && data.hilfetext.toLowerCase().indexOf(filter) !== -1)
        );
    });

    private sortingDataAccessor = (data: FeldBeschreibung, sortHeaderId: string): string | number => {
        const value = ObjectPathService.objectPath(data, sortHeaderId);

        if (value === undefined || value === null) {
            return '';
        }

        if (typeof value === 'string' && !value.trim()) {
            return value;
        }

        return value;
    };

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private feldBeschreibungService = inject(FeldBeschreibungService);
    private router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public columnsToDisplay = [
        'title',
        'hilfetext',
    ];

    ngOnInit() {
        this.feldBeschreibungList.filterPredicate = this.datasourceFilter;
        this.feldBeschreibungList.sort = this.sort;
        this.feldBeschreibungList.sortingDataAccessor = this.sortingDataAccessor;

        this.reloadData();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadData();
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    private reloadData() {
        this.feldBeschreibungService.listFeldBeschreibung()
            .pipe(take(1))
            .subscribe(kb => {
                this.feldBeschreibungList.data = kb;
                this.changeDetectorRef.markForCheck();
            });
    }

    public applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.feldBeschreibungList.filter = filterValue.trim().toLowerCase();
    }

    public openFeldBeschreibung(feld: FeldBeschreibung) {
        this.router.navigate([],
            {
                queryParams: { feld: feld.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsFeldBeschreibungDetailComponent);
    }
}
